import { render, staticRenderFns } from "./TxnInfoEdit.vue?vue&type=template&id=23513659&scoped=true"
import script from "./TxnInfoEdit.vue?vue&type=script&lang=js"
export * from "./TxnInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./TxnInfoEdit.vue?vue&type=style&index=0&id=23513659&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23513659",
  null
  
)

export default component.exports